

export { SearchBox } from './src/view/index';
